import { Route, Routes } from '@hulu/react-router-dom';
import React, { Suspense } from 'react';

import { StyledLoader } from '../../components/styled';
import { UnauthorizedRoute } from '../../components/UnauthorizedRoute';
import { RoutePath } from '../../constants';
import Login from '../../pages/Login';
import NotFound from '../../pages/NotFound';
import { commonMarketerAppRoutes } from '../commonRoutes/commonMarketerAppRoutes';

const MainRoutes = (): JSX.Element => (
  <Suspense fallback={<StyledLoader />}>
    <Routes>
      <Route path={RoutePath.HOME} element={<UnauthorizedRoute children={<Login />} />} />
      {commonMarketerAppRoutes.map((route) => (
        <Route key={route.path} {...route} />
      ))}
      <Route path="*" element={<NotFound />} />
    </Routes>
  </Suspense>
);

export default MainRoutes;
